import {
  Component, Output, EventEmitter, Inject, Renderer2,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { BaseModalComponent } from '../../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'take-over-modal',
  templateUrl: 'take-over-modal.component.html',
  styleUrls: ['take-over-modal.component.scss'],
})
export class TakeOverModalComponent extends BaseModalComponent {
  @Output() termsClicked = new EventEmitter();
  @Output() agreeClicked = new EventEmitter();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _renderer: Renderer2,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public show() {
    this._renderer.addClass(document.body, 'page-modal-open');
    super.show();
  }

  public hide() {
    this._renderer.removeClass(document.body, 'page-modal-open');
    super.hide();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onAgreeClick() {
    this.agreeClicked.emit();
  }

  onTermsClick(event: MouseEvent) {
    event.preventDefault();
    this.termsClicked.emit();
  }
}
